import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { PackageFareDetails } from "redmond";
import { MobilePackagesBookWorkflow } from "./component";
import { IStoreState } from "../../../../reducers/types";
import {
  getRewardsAccounts,
  getSelectedAccount,
} from "../../../rewards/reducer";
import {
  getHotelShopChosenProduct,
  getHotelShopChosenRoomInfo,
  getHotelShopDateRange,
  getPackageSelectedLodging,
  selectedPackageByRateId,
} from "../../../hotel-shop/reducer";
import {
  getFareTripDetailsById,
  getRecommendedFlights,
  getSelectedReturnFlightPackage,
  getSelectedTrip,
  selectedFareDetailsSelector,
  getIsTripInternational,
} from "../../../flight-shop/reducer";
import {
  getPackageAvailabilityAdultsCount,
  getPackageAvailabilityChildren,
  getPackageAvailabilityInfants,
  getPackageEntryPoint,
  getPackagesAvailabilityDepartureDate,
  getPackagesAvailabilityReturnDate,
} from "../../../availability/reducer";
import { getDestination, getOrigin } from "../../../search/reducer";
import { getFinalizePackageResponse } from "../../../itinerary-review/reducer/selectors";
import {
  getPackageSearchKey,
  getPackagedAirComponent,
  getPackagedRoomComponent,
  getPackageDisplayData,
  getPackagePollState,
} from "../../../package-identity/reducer/selectors";
import {
  toCancellationSummary,
  toPackagePricingFromSnapshot,
  toRoomInfoProducts,
  toSelectedRoomRateId,
} from "../../../hotel-shop/utils/packageSnapshotAdapters";

export const mapStateToProps = (state: IStoreState) => {
  const selectedTrip = getSelectedTrip(state);
  const hotelDates = getHotelShopDateRange(state);
  const fareDetails = selectedFareDetailsSelector(state) as
    | PackageFareDetails
    | undefined;

  const packagePricing = fareDetails?.packagePricing;

  const searchedAdultsCount = getPackageAvailabilityAdultsCount(state);
  const searchedChildren = getPackageAvailabilityChildren(state);
  const searchedInfants = getPackageAvailabilityInfants(state);
  const searchedDestination = getDestination(state);
  const searchedOrigin = getOrigin(state);
  const searchedDepartureDate = getPackagesAvailabilityDepartureDate(state);
  const searchedReturnDate = getPackagesAvailabilityReturnDate(state);
  const packageDiscountInfo = fareDetails?.discountInfo;

  const selectedLodging = getPackageSelectedLodging(state);

  const packageDisplayData = getPackageDisplayData(state);
  const packagedAirComponent = getPackagedAirComponent(state);
  const packagedRoomComponent = getPackagedRoomComponent(state);

  return {
    finalizePackageResponse: getFinalizePackageResponse(state),
    selectedTrip,
    tripDetails: selectedTrip?.tripId
      ? getFareTripDetailsById(state)[selectedTrip.tripId]
      : undefined,
    selectedLodging,
    selectedRoom: getHotelShopChosenRoomInfo(state),
    hotelFromDate: hotelDates?.from,
    hotelUntilDate: hotelDates?.until,
    packagePricing,
    rewardsAccounts: getRewardsAccounts(state),
    searchedAdultsCount,
    searchedChildren,
    searchedInfants,
    searchedDestination,
    searchedOrigin,
    searchedDepartureDate,
    searchedReturnDate,
    recommendedFlights: getRecommendedFlights(state),
    opaqueQuoteRequest: selectedPackageByRateId(state)?.opaqueQuoteRequest,
    opaquePackageToken:
      getSelectedReturnFlightPackage(state)?.opaquePackageToken,
    selectedAccount: getSelectedAccount(state),
    entryPoint: getPackageEntryPoint(state),
    packageDiscountInfo,
    selectedRoomRateId: getHotelShopChosenProduct(state)?.rateId?.value,
    isInternationalTrip: getIsTripInternational(state),
    searchKey: getPackageSearchKey(state),
    // v2-sourced: read from the GetPackage snapshot instead of the handoff.
    selectedRoomV2: packagedRoomComponent
      ? toRoomInfoProducts(packagedRoomComponent)
      : undefined,
    selectedRoomRateIdV2: packagedRoomComponent
      ? toSelectedRoomRateId(packagedRoomComponent)
      : undefined,
    cancellationSummaryV2: packagedRoomComponent
      ? toCancellationSummary(packagedRoomComponent)
      : undefined,
    packagePricingV2: packageDisplayData
      ? toPackagePricingFromSnapshot(
          packageDisplayData,
          packagedAirComponent,
          packagedRoomComponent
        )
      : undefined,
    packagedRoomComponentV2: packagedRoomComponent,
    packagePollState: getPackagePollState(state),
  };
};

export const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobilePackagesBookWorkflowConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMobilePackagesBookWorkflow = withRouter(
  connector(MobilePackagesBookWorkflow)
);
